import variables from  '../../variables.js';

export const emotionColorsArray = {
  joy: variables.joy,
  anger: variables.anger,
  fear: variables.fear,
  grief: variables.grief
};

export const moodColorsArray = [
  { value: 90, color: "#1c9f34" },
  { value: 80, color: "#2bf350" },
  { value: 60, color: "#99f37d" },
  { value: 50, color: "#ccff8b" },
  { value: 40, color: "#fff6df" },
  { value: 20, color: "#f3b376" },
  { value: "default", color: "#67051a" },
  { value: "undefined", color: "black" }
];

export const coronaColorsArray = [
  { value: 90, color: "#c70932" },
  { value: 85, color: "#df694b" },
  { value: 80, color: "#f3956b" },
  { value: 70, color: "#f3b376" },
  { value: 60, color: "#ffc472" },
  { value: 50, color: "#f0e25e" },
  { value: 40, color: "#efed6a" },
  { value: 30, color: "#fff063" },
  { value: 20, color: "#e4ff84" },
  { value: 10, color: "#ccff8b" },
  { value: 5, color: "#b3f37f" },
  { value: 0, color: "#99f37d" },
  { value: "isNaN", color: "black" },
  { value: "default", color: "#67051a" },
  { value: "undefined", color: "black" }
];
